import React, { ComponentType, Fragment, useState } from 'react';
import { SnapBadge } from '../../SnapBadge';
import { SnapButton } from '../../SnapButton';

export default function LogsList<T extends { created: Date }>({
  logs,
  token,
  LogComponent,
}: {
  logs: T[];
  token: string;
  LogComponent: ComponentType<{ log: T; token: string }>;
}): React.JSX.Element {
  const [activeIndex, setActiveIndex] = useState<number>();
  const formatDate = (inputDate: Date | string) => {
    const date = new Date(inputDate);
    const formattedDate = date.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
    return formattedDate;
  };
  return (
    <div className='p-6' style={{ overflowWrap: 'anywhere' }}>
      <table>
        <tbody>
          {logs.map((log, i) => {
            return (
              <tr key={i}>
                {activeIndex === i ? (
                  <td>
                    <SnapButton
                      className='text-white text-xl xl rounded-full bg-blue-100'
                      onClick={(): void => setActiveIndex(undefined)}
                    >
                      Back
                    </SnapButton>
                    <LogComponent log={log} token={token} />
                  </td>
                ) : (
                  <Fragment>
                    <td>
                      <SnapBadge size='large' label={formatDate(log.created)} />
                    </td>
                    <td>
                      <SnapButton
                        className='text-white text-xl xl rounded-full bg-blue-100 mx-1'
                        onClick={(): void => setActiveIndex(i)}
                      >
                        Open
                      </SnapButton>
                    </td>
                  </Fragment>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
